<template>
  <div>
    <!-- SubaruFlexSpaceBanner component start  -->
    <div v-if="isLandingPage" class="container">
      <div class="row">
        <div class="col-12 col-lg-8 mx-auto">
          <SubaruFlexSpaceBanner v-if="isLandingPage" pagename="home" />
          <!-- <h2>VUE3</h2> -->
        </div>
      </div>
    </div>
    <!-- SubaruFlexSpaceBanner component end  -->

    <div class="d-flex subaru-corporate justify-content-center custom-border">
      <div class="col-md-8 pt-4 pb-2">
        <VSlickCarousel 
        v-if="gallery?.length > 0"
        ref="slick" v-bind="slickOptions">
          <div v-for="(item, index) in gallery" :key="index" class="px-2">
            <img
              :src="item.image"
              class="img-fluid"
              style="cursor: pointer"
              :alt="item.altText"
              :width="imageDimensions?.width"
              :height="imageDimensions?.height"
              @click.prevent="onCorporateCellClick(item)"
            />
          </div>
        </VSlickCarousel>
      </div>
    </div>
    <div class="d-flex justify-content-center mb-2">
      <p class="custom-dot  active text-center" @click="leftArrowClick()" />
      <p class=" custom-dot text-center" @click="rightArrowClick()" />
    </div>
  </div>
</template>
<script src="./SubaruCorporateCell.js"></script>
<style scoped>
.custom-dot {
  background-color: rgb(101, 101, 101);
  border: none;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  margin: 0 5px;
  cursor: pointer;
}

.custom-dot.active {
  background-color: #007bff;
}
.subaru-corporate .custom-border {
  border-top: 2px solid #dfdfdf;
}

@media (max-width: 768px) {
  .subaru-corporate .slick-prev {
    left: 42% !important;
  }
}
.subaru-corporate :deep(.v-slick-dots li.active button:before) {
  color: #1971d4;
}
.subaru-corporate :deep(.v-slick-dots li button:before) {
  font-size: 18px;
}
</style>
